export const usdcToUsd = (coinCode = '') => {
  if (coinCode?.endsWith('_USDC')) {
    return coinCode.replace(/_USDC/, '_USD')
  }
  if (coinCode === 'USDC') {
    return 'USD'
  }
  return coinCode
};
